import { ScheduleConstraintTypeBase } from './base/schedule-constraint-type-base';

export class ScheduleConstraintType extends ScheduleConstraintTypeBase { }